
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionBlock, Text } from '../../talent.styled';
import { TitleAbout } from '../about/about.styled';

const NoInformation: React.FC = () => {
    const { t } = useTranslation('private-home-page');
    return (
        <SectionBlock>
            <TitleAbout>{t('talent.no-information')}</TitleAbout>
            <Text>
                <strong>{t('talent.no-information-description')}</strong>
            </Text>
        </SectionBlock>
    );
}

export default NoInformation;
